<div class="mt-4">
  <div class="table-responsive">
    <table
      class="table t-elevated-shadow-cap"
      aria-describedby="sesiones para DC3">
      <thead>
        <tr>
          <th scope="col">ID localizador</th>
          <th scope="col" *ngIf="showOwner">Propietario</th>
          <th scope="col">Sesi&oacute;n</th>
          <th scope="col">Fecha inicio</th>
          <th scope="col" class="text-center">#Partes</th>
          <th scope="col" class="text-center">QR Maestro</th>
          <th scope="col" class="text-center">Ver QR</th>
          <th scope="col" class="text-center">Compartir</th>
          <th scope="col" class="text-center">Asistencia</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sessionItem of sessions">
          <th scope="row">{{ sessionItem.IdLocalizador }}</th>
          <!-- Se muestra solo en globales -->
          <td *ngIf="showOwner">
            {{ getUserName(sessionItem.numeroPersona) }}
          </td>
          <td>
            {{ sessionItem.titulo }}
          </td>
          <td>
            {{
              sessionItem.fechaInicio
                | date: "dd/MM/yyyy" : "" : "es-mx"
                | titlecase
            }}
          </td>
          <td class="text-center">{{ sessionItem.totalPartesReales }}</td>
          <td class="text-center">{{ sessionItem.QrMeastro ? "Sí" : "No" }}</td>
          <th scope="row" class="text-center">
            <button
              mat-mini-fab
              class="mat-mini-custom"
              color="primary"
              ngbTooltip="Generar QR"
              (click)="myQRs(sessionItem)">
              <mat-icon>qr_code_2_add</mat-icon>
            </button>
          </th>
          <th scope="row" class="text-center">
            <button
              mat-mini-fab
              class="mat-mini-custom"
              color="primary"
              ngbTooltip="Compartir QR"
              (click)="shareWith(sessionItem)">
              <mat-icon>share</mat-icon>
            </button>
          </th>
          <th scope="row" class="text-center">
            <button
              mat-mini-fab
              class="mat-mini-custom"
              color="primary"
              ngbTooltip="Ver asistencia"
              [routerLink]="['/myQrs', 'view-attendece', sessionItem.Id]"
              routerLinkActive="router-link-active">
              <mat-icon>checklist</mat-icon>
            </button>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-general-empty-modal #modal [modalConfig]="modalConfig">
  <ng-container *ngIf="isMyQRModel && selectedSesion">
    <app-modal-course-card
      [data]="selectedSesion"
      (closeModalEmitter)="closeModal()"></app-modal-course-card>
  </ng-container>
  <ng-container *ngIf="isShareModel && selectedSesion">
    <app-modal-share-qr-card
      [data]="selectedSesion"
      (closeModalEmitter)="closeModal()"></app-modal-share-qr-card>
  </ng-container>
</app-general-empty-modal>
